import { useEffect, useState } from "react";
import { subscribe, resolveRetry } from "util/networkActivity";

/**
 * 전역 네트워크 오버레이 — 모든 API 통신 중 중앙 스피너, 30초 타임아웃/네트워크오류 시 '다시 시도'.
 *  networkActivity(axios 인터셉터가 구동)를 구독. 앱 루트에 1회 마운트.
 *  기존 .loader-dimmed/.loader-spinner CSS + btn 클래스 재사용(새 CSS 없음).
 */
export default function GlobalNetworkOverlay() {
  const [state, setState] = useState({ loading: false, retry: null });

  useEffect(() => subscribe(setState), []);

  useEffect(() => {
    const active = state.loading || !!state.retry;
    document.body.style.overflow = active ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [state.loading, state.retry]);

  if (state.retry) {
    return (
      <div className="loader-dimmed is-show" style={{ zIndex: 100000 }}>
        <div style={{ background: "#fff", borderRadius: "1.6rem", padding: "2.4rem 2rem", width: "80%", maxWidth: "32rem", textAlign: "center" }}>
          <p className="t-16-single fw-b fc-h" style={{ marginBottom: "0.8rem" }}>{state.retry.message}</p>
          <p className="t-14-single" style={{ marginBottom: "1.6rem", lineHeight: 1.5 }}>
            네트워크 상태를 확인한 뒤 다시 시도해 주세요.
          </p>
          <div className="btn-group">
            <button type="button" className="btn-md outlined" onClick={() => resolveRetry("cancel")}>닫기</button>
            <button type="button" className="btn-md filled primary" onClick={() => resolveRetry("retry")}>다시 시도</button>
          </div>
        </div>
      </div>
    );
  }

  if (state.loading) {
    return (
      <div className="loader-dimmed is-show" style={{ zIndex: 100000 }}>
        <div className="loader-spinner"></div>
        <span className="t-14-single fc-w"> 잠시만 기다려주세요.</span>
      </div>
    );
  }

  return null;
}
